import { useTranslation } from 'react-i18next'

import Statistic from '@/common/components/Statistic/Statistic'
import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'
import InfoTooltip from '@/metrics/components/InfoTooltip/InfoTooltip'
import {
  getLogisticsTeaser,
  getMarketsTeaser,
  getProductsTeaser,
} from '@/metrics/pages/PerformanceInsightsPage/GlobalTab/YourNumbersCard/helpers'

const ByViewTeasers = ({ numbers }) => {
  const { t, i18n } = useTranslation()

  const markets = getMarketsTeaser(numbers, t, i18n.language)
  const products = getProductsTeaser(numbers, t, i18n.language)
  const logistics = getLogisticsTeaser(numbers, t, i18n.language)

  return (
    <StatisticGroup>
      <Statistic
        isOutlined={false}
        label={t('Mercados')}
        labelAddon={<InfoTooltip text={t('Margen operativo de tu mercado con menos margen en este periodo.')} />}
        value={markets.value}
        caption={markets.caption}
      />
      <Statistic
        isOutlined={false}
        label={t('Productos')}
        labelAddon={
          <InfoTooltip text={t('Productos cuyo margen es negativo (venden por debajo de coste) en este periodo.')} />
        }
        value={products.value}
        caption={products.caption}
      />
      <Statistic
        isOutlined={false}
        label={t('Logística')}
        labelAddon={<InfoTooltip text={t('Parte de tu coste de envío que cubres (envío gratis) en este periodo.')} />}
        value={logistics.value}
        caption={logistics.caption}
      />
    </StatisticGroup>
  )
}

export default ByViewTeasers
